<template>
  <section id="new-analytics-banner" class="modal is-active" style="z-index: 3000">
    <div class="modal-background"></div>
    <div class="modal-card banner-container">
      <div class="close">
        <div class="btn" @click="$emit('close')">
          <i class="icon-cancel" />
        </div>
      </div>
      <div class="columns main-section">
        <div class="column is-7 left">
          <h1 class="title">
            {{ "banner.header" | t }}
          </h1>
          <div>
            <p class="sub">
              {{ "banner.start" | t }}
            </p>
            <p>
              <span class="highlight">
                {{ "banner.highlight" | t }}
              </span>
              <span class="sub">
                {{ "banner.end" | t }}
              </span>
            </p>
          </div>
          <div class="columns btn-section">
            <button class="button is-rounded btn-close" @click="$emit('close')">
              {{ "banner.close" | t }}
            </button>
            <button class="button is-rounded btn-try" @click="openAnalytics()">
              {{ "banner.try" | t }}
            </button>
          </div>
        </div>
        <div class="column is-5 right">
          <div class="img-placeholder" :style="{ 'background-image': 'url(' + imageUrl + ')' }"></div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { ANALYTICS_LINK } from "@/lib/constants";
export default {
  data: function () {
    return {
      imageUrl: require("@/assets/images/dashboard.png"),
    };
  },
  methods: {
    openAnalytics() {
      window.open(ANALYTICS_LINK, "_blank");
    },
  },
};
</script>

<style scoped lang="scss">
.banner-container {
  min-width: 960px;
  background: #fff;
  padding: 28px 0px 80px 28px;
  & .close {
    display: flex;
    justify-content: flex-end;
    & .btn {
      font-size: 22px;
      margin-right: 28px;
      &:hover {
        cursor: pointer;
      }
    }
  }
  & .main-section {
    padding-left: 58px;
    & .left {
      .title {
        font-style: normal;
        font-weight: 700;
        font-size: 32px;
        line-height: 128%;
        max-width: 75%;
        color: #383838;
      }
      .sub {
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 22px;
        /* or 156% */

        /* gray-800 */

        color: #7f8382;
      }
      .highlight {
        font-style: normal;
        font-weight: 800;
        font-size: 14px;
        line-height: 22px;
        /* or 156% */

        /* gray-800 */

        color: #191919;
      }
    }
    & .right {
      width: 52%;
      .img-placeholder {
        margin-top: 28px;
        height: 100%;
        width: 100%;
        background-position-x: 3cm;
        background-repeat: no-repeat;
        background-size: contain;
        background-position-x: 1.5cm;
      }
    }
    & .btn-section {
      margin-top: 32px;
      padding-left: 8px;
    }
    & .btn-close {
      font-style: normal;
      font-weight: 700;
      font-size: 18px;
      line-height: 24px;
      /* identical to box height, or 133% */
      margin-right: 16px;
      display: flex;
      align-items: center;

      /* Primary (Light UI) */

      color: #383838;
    }
    & .btn-try {
      font-style: normal;
      font-weight: 700;
      font-size: 18px;
      line-height: 24px;
      /* identical to box height, or 133% */
      background: #383838;
      display: flex;
      align-items: center;

      /* white */

      color: #ffffff;
    }
  }
}

.buttons {
  margin-top: 30px;

  .columns {
    width: 100%;
  }
}
</style>
